/** Bus de progreso de exportación Confronta (Excel/PDF) — overlay fuera del acordeón. */
const EVENT = "vf:confronta-export-progress";

export function publishConfrontaExportProgress(progress) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: progress }));
}

export function subscribeConfrontaExportProgress(handler) {
  if (typeof window === "undefined") return () => {};
  const listener = (ev) => handler(ev.detail ?? null);
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
